import React from 'react';
import Pages from "../../components/layout/Pages";
import useGet from "../../components/hooks/useGet";
import BackendForm from "../../components/forms/BackendForm";
import FloatingLabelField from "../../components/forms/FloatingLabelField";
import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Link} from "react-router-dom";
import {routes} from "../../utils";
import {concepts, User} from "fearless-common";
import {backendEndpoints} from "../../libs/backendEndpoints";
import useAuth from "../../components/hooks/useAuth";
import ProfilePicture from "../../components/ProfilePicture";
import UserCustomFields from "../../components/forms/UserCustomFields";
import {FormText} from "react-bootstrap";
import {DataRow} from "../../components/layout";
import useTitle from "../../components/hooks/useTitle";
import headerToTitle from "../../utils/headerToTitle";

const header = [
    { label: 'My Account'},
    { label: concepts.PersonalInformation, href: routes.personalInformation },
    { label: 'Edit' },
];


export default function PersonalInformationForm() {
    const { reloadUser, user } = useAuth();
    const { data, isLoading, error } = useGet<User>({ endpoint: '/me' });

    useTitle(headerToTitle(header.map(h => h.label)))

    return (
        <Pages.UserBase header={header}>
            {!isLoading}
            {error && <Alert>{error}</Alert>}
            {data && (
                <Row className="gap-2">
                    <Col sm={2}>
                        {user && <ProfilePicture user={user} size="100%" canEdit onSuccess={reloadUser}  />}
                    </Col>
                    <Col className="max-width-700">
                        <BackendForm
                            initialValues={data}
                            targetEndpoint={backendEndpoints.updateUser(data.id)}
                            targetMethod="PUT"
                        >
                            <Row className="mb-3">
                                <Col>
                                    <FloatingLabelField name="first_name" label="First name"/>
                                </Col>
                                <Col>
                                    <FloatingLabelField name="last_name" label="Last name"/>
                                </Col>
                            </Row>
                            <FloatingLabelField
                                name="email"
                                label="Email"
                                helperText="You will have to verify your new email."
                            />
                            <FloatingLabelField name="username" label="Username" />
                            <div className="px-4">
                                <DataRow label="Password" vertical>
                                    <FormText>
                                        If you want to change your password, please click&nbsp;
                                        <Link className="btn-link" to={routes.forgotPassword}>here</Link>.
                                    </FormText>
                                </DataRow>
                            </div>

                            <div className="mt-5">&nbsp;</div>
                            <FloatingLabelField name="organisation" label="Organization"/>
                            <FloatingLabelField name="group_name" label={concepts.GroupName} />
                            <FloatingLabelField name="position" label="Position"/>

                            <div className="mt-5">
                                <UserCustomFields />
                            </div>
                        </BackendForm>
                    </Col>
                </Row>
            )}
        </Pages.UserBase>
    );
}
